// src/components/Assets/Templates/Normal1/normal1.js
export default `
  <!DOCTYPE html>
<html lang="en" dir="ltr" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<meta charset="utf-8">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="viewport" content="width=device-width,initial-scale=1">
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no">
<meta name="x-apple-disable-message-reformatting">
<meta name="color-scheme" content="light dark">
<meta name="supported-color-schemes" content="light dark">
<!--[if (gte mso 9)|(IE)]><!-->
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Roboto:wght@400;700;900&display=swap" rel="stylesheet">
<!--<![endif]-->
<title>Email title</title>
<!--	outlook dpi code start -->
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<style>
table { border-collapse: collapse; mso-table-lspace: 0px; mso-table-rspace: 0px; }
tr {font-size:0px;line-height:0px;}
sup { font-size:66%;line-height:100%;mso-text-raise: 0%;}
li {margin-left:-23px !important}

//Use only when using a non-websafe font
body { margin: 0 !important; padding: 0 !important; font-family: Helvetica, sans-serif !important;}
body, table, td, a, span, p, h1, h2, h3, h4 { font-family: Helvetica, sans-serif !important;} 
</style>
<![endif]-->
	
<!--	outlook dpi code end -->

<style>
    * a {color: inherit !important; text-decoration: none;}
:root {
color-scheme: light dark;
supported-color-schemes: light dark;
}
/* Fix for Outlook links color fix for links and visited links */
span.MsoHyperlink {color: inherit !important;mso-style-priority: 99 !important;text-decoration: underline !important;}

span.MsoHyperlinkFollowed {color: inherit !important;mso-style-priority: 99 !important;}
/* normalise link attributes in Outlook app iOS/Android - to match the parent element */
body[data-outlook-cycle] a {color: inherit !important;text-decoration: none !important;}
/* normalise link attributes in Apple Mail / iOS Mail apps - to match the parent element */
a[x-apple-data-detectors] {color: inherit!important;text-decoration: none!important;font-size: inherit!important;font-family: inherit!important;font-weight: inherit!important;line-height: inherit!important;}
#root [x-apple-data-detectors=true],a[x-apple-data-detectors=true]{
color: inherit !important;text-decoration: inherit !important;}
#main #inner a[x-apple-data-detectors]{color: inherit !important;
text-decoration: inherit !important;}
a[href^=tel], #MessageViewBody a, a[x-apple-data-detectors], #body a, .link {color: inherit;text-decoration: none;font-size: inherit;
font-family: inherit;font-weight: inherit;line-height: inherit;}
[data-outlook-cycle] [x-apple-data-detectors-type="calendar-event"] {color: inherit !important;-webkit-text-decoration-color: inherit !important;text-decoration: none !important;}
/* normalise link attributes in Gmail - to match the parent element */
u + #body a {color: inherit;text-decoration: none;font-size: inherit;font-weight: inherit;line-height: inherit;}
#preheader,#preview-spacer {display: none;display:none!important;}
ul {padding-left: 17px !important;}
ol {padding-left: 17px !important;}
hr{margin: 0 !important;}
input{display: none;}
u ~ div img + div > div  {display:none}
.faux-absolute{max-height:0;position:relative;opacity:0.999;}
/*Mobile CSS*/
@media only screen and (max-width: 480px){
.w320a{width: 400px !important;} 
.w320{width: 360px !important;} 
.w100 {width: 100%!important; min-width: 100%!important; max-width: 1000px!important; height: auto!important;}
.img100 {width: auto!important; height: auto!important; display: block!important;}
.img100w{width: 100% !important;}
.nomob {display: none!important;width: 0px!important;height: 0px!important;}
.show {display: block!important;overflow: visible!important;float: none!important;width: 100%!important;height: auto!important;max-height: inherit!important;}
.table{display: table !important; width: 100% !important;}/*Add this in tr*/
.display-footer {display: table-footer-group!important;width: 100%!important;min-width: 100%!important;}
.display-header {display: table-header-group!important;width: 50%!important;min-width: 100%!important;}
.drop {width: 100%!important;float: left!important;display: block!important;}
    
}

/*Mobile CSS*/
@media only screen and (max-width: 410px){
.w320{width: 280px !important;}
.w320a{width: 320px !important;}
    
    }
</style>
<style>
u + .body .gmail-blend-screen { background:#000; mix-blend-mode:screen; }
u + .body .gmail-blend-difference { background:#000; mix-blend-mode:difference; }
</style>
<style>
/*	Darkmode code for the IOS start*/
@media (prefers-color-scheme: dark ) {
.mainbg { background-color: #000 !important; }
.darkmode { background-color: #272623 !important; }
h1, h2, p, span, a, b, ul, li, ol { color: #ffffff !important; }
.darktext h1, .darktext h2, .darktext p, .darktext span{ color: #000 !important; }
.textBlue{color: #223c83 !important;}
.textBlack{color: #000 !important;}

/* OUTLOOK APP (ANDROID) DARK MODE STYLES */
[data-ogsc] .mainbg { background-color: #000 !important; }
[data-ogsc] .darkmode { background-color: #272623 !important; }
[data-ogsc] h1, [data-ogsc] h2, [data-ogsc] p, [data-ogsc] span, [data-ogsc] a, [data-ogsc] b, [data-ogsc] ul, [data-ogsc] li, [data-ogsc] ol { color: #ffffff !important; }
[data-ogsc] .darktext h1, [data-ogsc] .darktext h2, [data-ogsc] .darktext p, [data-ogsc] .darktext span, .darktext li{ color: #000 !important; }
[data-ogsc].textBlue{color: #223c83 !important;}
[data-ogsc].textBlack{color: #000 !important;}
}
/*	Darkmode code for the IOS end*/
</style>
  
</head>
<body class="body mainbg" style="margin: 0; padding: 0; background-color: #ffffff;">
  <div id="preheader" style="display: none; font-size: 0; line-height: 0; mso-hide: all; color: #e3e3e3;">Preheader Text</div>

<div id="preview-spacer" style="display: none; font-size: 0; line-height: 0; mso-hide: all; color: #e3e3e3;">&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;</div>
  <div role="article" aria-roledescription="email" aria-label="email name" lang="en" dir="ltr" style="font-size:16px; font-size:1rem; font-size:max(16px, 1rem)">
    
<table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" class="mainbg">
<tr>
<td align="center">
<div id="main">
	<div id="inner">
		<table width="660" border="0" cellspacing="0" cellpadding="0" style="width: 660px;" class="w320a">
  <tbody>
    <tr>
      <td align="center" style="background-color: #F0F0F4;">
		<table width="600" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 600px;" class="darkmode w320" bgcolor="#F0F0F4">
  <tbody>
    <tr>
      <td align="center">
        <h1 style="margin: 30px 0px 30px 0px; color: green">Srihari Muppalla</h1>
        </td>
    </tr>
    <tr><td style="padding: 0px 0px 10px 0px;">
      <img src="https://sriharim.in/Assets/normal/n3-banner.jpg" alt="Srihari Muppalla" width="100%" style="width: 100%; border: 0px; display: block;" />
    </td></tr>
    <tr>
      <td align="center">
        <p style="font-family: Arial; font-size: 18px; line-height: 20px; margin: 20px 0px 20px 0px; color: #0e110e; text-align: left; font-weight: 700;">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </td>
    </tr>
	  <tr>
	  <td style="padding: 20px 0px 20px 0px;">
		<img src="https://sriharim.in/Assets/normal/n3-card1.png" style="width: 300px; height: 155px; margin: 0px 30px 20px 0px; float: left;" width="300" height="155" alt="Srihari Muppall" align="left" class="w100"><!--[if mso]>
		<img src="https://placehold.jp/30/ffffff/ffffff/20x10.png" style="width: 20px; height: 160px; float: left;" width="20" height="160" alt="Srihari Muppall" align="left" class="nomob"><![endif]-->
		<font style="font-family: Arial; font-size: 16px; line-height: 20px; mso-line-height-rule: exactly; font-weight: bold;">Srihari Muppalla</font><br><br>
		<font style="font-family: Arial; font-size: 16px; line-height: 20px; mso-line-height-rule: exactly;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec dapibus placerat odio, id dapibus orci imperdiet eget. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Ut ultrices cursus nisi a ullamcorper. Pellentesque quis eleifend ligula. Etiam et augue ac orci sodales rhoncus. Cras quis aliquam leo, et ultrices est. Cras orci velit, rhoncus eu nisl sagittis, sagittis cursus eros. Nunc lobortis cursus gravida. Proin orci nibh, dapibus at commodo a, viverra a mi. Etiam libero lorem, mollis sit amet lacinia sit amet, tempus ut augue.
		  
		 </font>
	  </td>
	  </tr>
    <tr>
      <td align="center">
        <p style="font-family: Arial; font-size: 18px; line-height: 20px; margin: 20px 0px 20px 0px; color: #0e110e; text-align: left; font-weight: 700;">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </td>
    </tr>
    <tr>
      <td>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 100%;">
          <tbody>
            <tr>
              <td width="30%" style="width: 30%;" align="center" valign="top" class="drop">
                <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 100%;" align="center">
                  <tbody>
                    <tr><td>
                      <p style="margin: 0px 0px 20px 0px;"><img src="https://sriharim.in/Assets/normal/n3-card2.jpg" alt="" width="180px" style="width: 180px; border: 0px; display: block;" class="w100" /></p>
                      <p style="font-family: Arial; font-size: 16px; line-height: 20px; margin: 0px 0px 20px 0px; color: #0e110e; text-align: left; font-weight: normal;">Lorem ipsum dolor sit amet</p>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td align="left" style="border-width: 0px; height: 44px; text-align: center; color: rgb(255, 255, 255); padding-top: 0px; padding-bottom: 0px; font-family: Arial, Helvetica, sans-serif; font-weight: 400; text-decoration: none; vertical-align: middle; background-color: rgb(0, 0, 0);"><a title="Get started" style="color: rgb(255, 255, 255); line-height: 256%; font-size: 16px; font-weight: normal; text-decoration: none;" href="https://srihari.site" target="_blank">View More</a></td>
                          </tr>
                        </tbody>
                      </table>
                    </td></tr>
                  </tbody>
                </table>
              </td>
              <td width="5%" height="20" style="width: 5%; height: 20px;" class="drop"></td>
              <td width="30%" style="width: 30%;" align="center" valign="top" class="drop">
                <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 100%;" align="center">
                  <tbody>
                    <tr><td>
                      <p style="margin: 0px 0px 20px 0px;"><img src="https://sriharim.in/Assets/normal/n3-card2.jpg" alt="" width="180px" style="width: 180px; border: 0px; display: block;" class="w100" /></p>
                      <p style="font-family: Arial; font-size: 16px; line-height: 20px; margin: 0px 0px 20px 0px; color: #0e110e; text-align: left; font-weight: normal;">Lorem ipsum dolor sit amet</p>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td align="left" style="border-width: 0px; height: 44px; text-align: center; color: rgb(255, 255, 255); padding-top: 0px; padding-bottom: 0px; font-family: Arial, Helvetica, sans-serif; font-weight: 400; text-decoration: none; vertical-align: middle; background-color: rgb(0, 0, 0);"><a title="Get started" style="color: rgb(255, 255, 255); line-height: 256%; font-size: 16px; font-weight: normal; text-decoration: none;" href="https://srihari.site" target="_blank">View More</a></td>
                          </tr>
                        </tbody>
                      </table>
                    </td></tr>
                  </tbody>
                </table>
              </td>
              <td width="5%" height="20" style="width: 5%; height: 20px;" class="drop"></td>
              <td width="30%" style="width: 30%;" align="center" valign="top" class="drop">
                <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 100%;" align="center">
                  <tbody>
                    <tr><td>
                      <p style="margin: 0px 0px 20px 0px;"><img src="https://sriharim.in/Assets/normal/n3-card2.jpg" alt="" width="180px" style="width: 180px; border: 0px; display: block;" class="w100" /></p>
                      <p style="font-family: Arial; font-size: 16px; line-height: 20px; margin: 0px 0px 20px 0px; color: #0e110e; text-align: left; font-weight: normal;">Lorem ipsum dolor sit amet</p>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td align="left" style="border-width: 0px; height: 44px; text-align: center; color: rgb(255, 255, 255); padding-top: 0px; padding-bottom: 0px; font-family: Arial, Helvetica, sans-serif; font-weight: 400; text-decoration: none; vertical-align: middle; background-color: rgb(0, 0, 0);"><a title="Get started" style="color: rgb(255, 255, 255); line-height: 256%; font-size: 16px; font-weight: normal; text-decoration: none;" href="https://srihari.site" target="_blank">View More</a></td>
                          </tr>
                        </tbody>
                      </table>
                    </td></tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr><td style="padding: 0px 0px 30px 0px;">
      <p style="font-family: Arial; font-size: 18px; line-height: 20px; margin: 30px 0px 20px 0px; color: #0e110e; text-align: left; font-weight: 700;">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
      <p style="font-family: Arial; font-size: 16px; line-height: 20px; margin: 0px 0px 20px 0px; color: #0e110e; text-align: left; font-weight: normal;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec dapibus placerat odio, id dapibus orci imperdiet eget. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Ut ultrices cursus nisi a ullamcorper. Pellentesque quis eleifend ligula. Etiam et augue ac orci sodales rhoncus. Cras quis aliquam leo, et ultrices est. Cras orci velit, rhoncus eu nisl sagittis, sagittis cursus eros. Nunc lobortis cursus gravida. Proin orci nibh, dapibus at commodo a, viverra a mi. Etiam libero lorem, mollis sit amet lacinia sit amet, tempus ut augue. </p>
      <table width="200" border="0" cellspacing="0" cellpadding="0" style="width: 200px;">
        <tbody>
          <tr>
            <td width="200" align="left" style="width: 200px; border-width: 0px; height: 44px; text-align: center; color: rgb(255, 255, 255); padding-top: 0px; padding-bottom: 0px; font-family: Arial, Helvetica, sans-serif; font-weight: 400; text-decoration: none; vertical-align: middle; background-color: rgb(0, 0, 0);"><a title="Get started" style="color: rgb(255, 255, 255); line-height: 256%; font-size: 16px; font-weight: normal; text-decoration: none;" href="https://srihari.site" target="_blank">View More</a></td>
          </tr>
        </tbody>
      </table>
    </td></tr>
  </tbody>
</table>
		
		</td>
    </tr>
  </tbody>
</table>

        
	</div>
	</div>
</td>
</tr>
</table>
  </div>
</body>
</html>
`;